import Ajax from '@/services/Ajax';
import { API_BASE_URL } from '@/config';

class HttpClient {
  static transformResponse = response => response.data;

  constructor({ baseURL }) {
    this.ajax = new Ajax({
      baseURL,
      transformResponse: HttpClient.transformResponse,
    });
  }

  get(route, headers, config) {
    return this.ajax.request('GET', route, {}, headers, config);
  }

  post(route, payload, headers, config) {
    return this.ajax.request('POST', route, payload, headers, config);
  }
}

export default new HttpClient({ baseURL: API_BASE_URL });



// WEBPACK FOOTER //
// ./src/services/httpClient.js